import { cn, tv, VariantProps } from "@utils/tw"
import { Link } from "eddev/routing"
import { ComponentProps } from "react"

type Props = ComponentProps<"a"> & VariantProps<typeof chipStyles>

export function Chip({ rounded, variant, ...props }: Props) {
  const styles = chipStyles({ rounded, variant })
  const Component = (props.onClick ? "button" : "href" in props && props.href ? Link : "div") as "a"

  return (
    <Component {...props} className={cn(styles, props.className)}>
      {props.children}
    </Component>
  )
}

const chipStyles = tv({
  base: "w-fit flex items-center justify-center type-label-s px-2 py-1",
  variants: {
    rounded: {
      true: "rounded-full px-3",
    },
    variant: {
      solid: "bg-white text-blue",
      invert: "bg-blue text-white",
      outline: "border border-blue text-blue",
      disabled: "border border-blue text-blue",
    },
  },
})
